import styled from "styled-components";

import { colorsPalettes, fonts, setFontVariant } from "@similarweb/styles";
import { Tab, TabList, TabPanel } from "@similarweb/ui-components";

export const StyledTab = styled(Tab).attrs<{ "data-automation-selected"?: boolean }>(({ selected }) => ({
    "data-automation-selected": selected,
}))`
    ${setFontVariant("button", colorsPalettes.carbon[300])};

    line-height: 16px;
    min-width: 192px;

    padding-top: 16px;
    padding-bottom: 15px;

    &:hover:not(.selected) {
        color: ${colorsPalettes.carbon["400"]};
    }

    &.selected {
        color: ${colorsPalettes.blue["400"]};
    }

    & span {
        font-family: ${fonts.$dmSansFontFamily};
    }

    &.disabled {
        .SWReactIcons svg path {
            fill: ${colorsPalettes.carbon[100]};
        }
    }
`;

StyledTab.tabsRole = "Tab";

export const StyledTabList = styled(TabList)`
    flex-shrink: 0;
    padding: 0 32px;
    box-sizing: border-box;

    border-color: ${colorsPalettes.carbon["100"]};
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledTabPanel = styled(TabPanel).attrs<{ "data-automation-selected"?: boolean }>(({ selected }) => ({
    "data-automation-selected": selected,
}))`
    flex-grow: 1;
    min-height: 0;
`;

export const StyledTabsContainer = styled.div`
    flex-grow: 1;
    min-height: 0;

    & .page-content-tabs {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
`;
